import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { RecipeList } from './RecipeList'
import { RecipeSearchInput } from './RecipeSearchInput'
import { useRecipeSearch } from './useRecipeSearch'

export function RecipesView() {
  const { t } = useTranslation('recipes')
  const { query, setQuery, recipes, isLoading } = useRecipeSearch()

  return (
    <div className="px-4 pt-4 pb-24">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold text-ink">{t('title')}</h1>
        <Link
          to="/recipes/new"
          aria-label={t('list.addAriaLabel')}
          className="flex items-center justify-center min-h-[44px] min-w-[44px] bg-accent text-white rounded-full shadow print:hidden"
        >
          <Plus className="h-5 w-5" aria-hidden="true" />
        </Link>
      </div>
      <div className="mb-4">
        <RecipeSearchInput value={query} onChange={setQuery} />
      </div>
      <RecipeList
        recipes={recipes}
        isLoading={isLoading}
        searchQuery={query}
        onClearSearch={() => setQuery('')}
      />
    </div>
  )
}
